(() => {
  const bootKey = '__hanmacRevision2PhotoViewer';
  if (window[bootKey]) {
    window[bootKey]();
    return;
  }
  if (typeof HTMLDialogElement === 'undefined' || typeof HTMLDialogElement.prototype.showModal !== 'function') return;
  const viewers = new WeakMap();
  const sourceSelector = '.hm-r2g-inspect, .hm-r2g-image, .hm-r2g-figure figcaption a';
  let activeViewer = null;

  function isPlainClick(event) {
    return !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
  }

  function getImageUrl(anchor) {
    try {
      const url = new URL(anchor.href, window.location.href);
      const approvedHost = url.hostname === 'cdn.shopify.com' || url.origin === window.location.origin;
      const approvedPath = url.hostname === 'cdn.shopify.com' || url.pathname.startsWith('/cdn/shop/');
      if (url.protocol !== 'https:' || !approvedHost || !approvedPath || !/\.(?:avif|gif|jpe?g|png|webp)$/i.test(url.pathname)) return null;
      return url.href;
    } catch {
      return null;
    }
  }

  function setMode(state, mode) {
    state.viewport.dataset.mode = mode;
    state.fit.setAttribute('aria-pressed', String(mode === 'fit'));
    state.native.setAttribute('aria-pressed', String(mode === 'native'));
    state.hint.hidden = mode !== 'native';
    state.viewport.scrollLeft = 0;
    state.viewport.scrollTop = 0;
  }

  function enhanceLinks(state) {
    state.root.querySelectorAll(sourceSelector).forEach((anchor) => {
      if (!getImageUrl(anchor)) return;
      anchor.setAttribute('aria-haspopup', 'dialog');
      anchor.setAttribute('aria-controls', state.dialog.id);
    });
  }

  function initialize() {
    document.querySelectorAll('[data-hm-r2pv]').forEach((dialog) => {
      const root = document.getElementById(dialog.dataset.rootId);
      if (!root) return;
      if (viewers.has(root)) {
        enhanceLinks(viewers.get(root));
        return;
      }
      const find = (name) => dialog.querySelector(`[data-hm-r2pv-${name}]`);
      const state = {dialog, root, viewport:find('viewport'), image:find('image'), status:find('status'), caption:find('caption'), original:find('original'), close:find('close'), fit:find('fit'), native:find('native'), hint:find('hint'), trigger:null, previousOverflow:''};
      if ([state.viewport, state.image, state.status, state.caption, state.original, state.close, state.fit, state.native, state.hint].some((value) => !value)) return;
      viewers.set(root, state);
      enhanceLinks(state);
      state.close.addEventListener('click', () => dialog.close());
      state.fit.addEventListener('click', () => setMode(state, 'fit'));
      state.native.addEventListener('click', () => {
        setMode(state, 'native');
        state.viewport.focus();
      });
      state.image.addEventListener('load', () => {
        if (!dialog.open || !state.image.naturalWidth) return;
        state.image.width = state.image.naturalWidth;
        state.image.height = state.image.naturalHeight;
        state.image.hidden = false;
        state.status.hidden = true;
        state.fit.disabled = false;
        state.native.disabled = false;
      });
      state.image.addEventListener('error', () => {
        if (!dialog.open) return;
        state.image.hidden = true;
        state.status.hidden = false;
        state.status.textContent = state.status.dataset.error;
        state.fit.disabled = true;
        state.native.disabled = true;
      });
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        state.image.removeAttribute('src');
        state.image.hidden = true;
        if (activeViewer !== state) return;
        document.documentElement.style.overflow = state.previousOverflow;
        activeViewer = null;
        if (state.trigger && state.trigger.isConnected) state.trigger.focus({preventScroll:true});
      });
    });
  }

  document.addEventListener('click', (event) => {
    if (!isPlainClick(event)) return;
    const anchor = event.target instanceof Element ? event.target.closest('a') : null;
    if (!anchor || !anchor.matches(sourceSelector)) return;
    const root = anchor.closest('.hm-r2-product');
    const state = root && viewers.get(root);
    const url = state && getImageUrl(anchor);
    if (!state || !url) return;
    const sourceImage = anchor.querySelector('img') || anchor.closest('figure')?.querySelector('img');
    if (!sourceImage) return;
    const previousOverflow = activeViewer ? activeViewer.previousOverflow : document.documentElement.style.overflow;
    if (activeViewer && activeViewer !== state) activeViewer.dialog.close();
    state.trigger = anchor;
    state.image.hidden = true;
    state.fit.disabled = true;
    state.native.disabled = true;
    state.status.hidden = false;
    state.status.textContent = state.status.dataset.loading;
    const scene = anchor.closest('.hm-r2g-scene');
    const caption = scene?.querySelector('figcaption > span')?.textContent || sourceImage.alt || '';
    state.image.alt = caption;
    state.caption.textContent = caption;
    state.original.href = url;
    setMode(state, 'fit');
    try {
      state.dialog.showModal();
    } catch {
      return;
    }
    event.preventDefault();
    state.previousOverflow = previousOverflow;
    document.documentElement.style.overflow = 'hidden';
    activeViewer = state;
    state.image.src = url;
    state.close.focus();
  });
  window[bootKey] = initialize;
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
})();
